import { useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryPopupController } from "@/ContactDirectory/Components/DirectoryPopupController";
import { FaxDirectorySearchComponent } from "@/ContactDirectory/Components/Search/FaxDirectorySearchComponent";
import { FaxDirectorySearchResultItem } from "@/ContactDirectory/Components/Search/FaxDirectorySearchResultItem";
import { IDirectoryEntity } from "@/ContactDirectory/Models/IDirectoryEntity";

import styles from "./RecipientContactDirectorySearchAndModify.module.scss";

interface IRecipientDetailsContactDirectorySearchProps {
    text?: string;
    fieldLabel: string;
    headerLabel: string;
    isValid: boolean;
    onContactSelect: (entity: IDirectoryEntity) => void;
    onTextChangedFunction?: (nextText: string) => void;
}

export function RecipientContactDirectorySearchAndModify(props: IRecipientDetailsContactDirectorySearchProps): JSX.Element {
    const { getText } = useTranslation();
    const [isAddToDirectoryPopupOpen, setIsAddToDirectoryPopupOpen] = useState<boolean>(false);

    return (
        <div className={styles.container}>

            <div className={styles.header}>
                <h4 className={styles.title}>
                    {props.headerLabel}
                </h4>
                <div className={styles.link}>
                    <a onClick={() => setIsAddToDirectoryPopupOpen(true)}>
                        {getText("AddToDirectoryLabel")}
                    </a>
                </div>
            </div>

            {isAddToDirectoryPopupOpen && (
                <DirectoryPopupController
                    onSave={(entity: IDirectoryEntity) => {
                        props.onContactSelect(entity);
                        setIsAddToDirectoryPopupOpen(false);
                    }}
                    onClose={() => setIsAddToDirectoryPopupOpen(false)}
                    editModel={null}
                    onEntityUseInstead={(entity: IDirectoryEntity) => {
                        props.onContactSelect(entity);
                        setIsAddToDirectoryPopupOpen(false);
                    }}
                    onModify={(entity: IDirectoryEntity) => {
                        props.onContactSelect(entity);
                        setIsAddToDirectoryPopupOpen(false);
                    }}
                />
            )}

            <div className={styles.recipient}>
                <label className="form-label">{props.fieldLabel}</label>
            </div>
            <div className={styles.textbox}>
                <FaxDirectorySearchComponent
                    onItemSelected={(selection: FaxDirectorySearchResultItem) => {
                        props.onContactSelect(selection?.entity);
                    }}
                    entityTypes={[DirectoryEntityType.HealthcareProvider, DirectoryEntityType.Pharmacy, DirectoryEntityType.Other]}
                    isValid={props.isValid}
                    filterExternalConsultants
                    searchText={props.text}
                    dataCy="contactDirectory-externalConsultantSearch"
                    onSearchTextChanged={props.onTextChangedFunction}
                />
            </div>

        </div>
    );
}
